import * as React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import DownloadIcon from '@mui/icons-material/Download'
import { useTranslation } from 'react-i18next'

interface IPopupDialog {
  downloadLink: string
  label?: string | React.ReactNode
  disabled?: boolean
  icon?: React.ReactNode
  isLoading?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const ActionButton: React.FC<IPopupDialog> = ({
  downloadLink,
  label,
  disabled,
  icon,
  isLoading,
  type,
}) => {
  const { t } = useTranslation()
  let useIcon: React.ReactNode = <DownloadIcon />
  if (icon) {
    useIcon = icon
  }
  if (isLoading) {
    useIcon = <CircularProgress color="inherit" size={20} />
  }
  return (
    <Button
      size="small"
      variant="contained"
      startIcon={useIcon}
      disabled={isLoading || disabled}
      type={type}
      href={downloadLink}
      download
      target="_blank"
      sx={{ margin: '5px' }}
    >
      {label ?? t('buttons.download')}
    </Button>
  )
}

export default ActionButton
